import { render } from "./TemplateSheetMenu.vue?vue&type=template&id=e88b6f52"
import script from "./TemplateSheetMenu.vue?vue&type=script&lang=js"
export * from "./TemplateSheetMenu.vue?vue&type=script&lang=js"
script.render = render

export default script